import { render, staticRenderFns } from "./RegistrationViaMail.vue?vue&type=template&id=208b2f41&scoped=true"
import script from "./RegistrationViaMail.vue?vue&type=script&lang=js"
export * from "./RegistrationViaMail.vue?vue&type=script&lang=js"
import style0 from "./RegistrationViaMail.vue?vue&type=style&index=0&id=208b2f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b2f41",
  null
  
)

export default component.exports